<ng-container *transloco="let t; read 'home.calculator'" [formGroup]="formGroup">
  <psc-select
    [hidden]="!advanced"
    formControlName="tariff_group"
    [label]="t('tariff_group.title')"
    [infoText]="t('tariff_group.info')"
    [isDisabled]="tariffGroupDisabled"
    [options]="tariffModelOptions"
    [loading]="loadingTariffs"></psc-select>

  <ng-container *transloco="let g; read 'home.calculator.type_calculation.values'">
    <!-- t(home.calculator.type_calculation.values.NO_FEED_IN_ENERGY) -->
    <!-- t( home.calculator.type_calculation.values.HR_FEED_IN_NET, home.calculator.type_calculation.values.HR_FEED_IN_CALC)-->
    <!-- t( home.calculator.type_calculation.values.BA_RS_FEED_IN_NET, home.calculator.type_calculation.values.BA_RS_FEED_IN_CALC)-->
    <!-- t( home.calculator.type_calculation.values.BA_FE_FEED_IN_NET, home.calculator.type_calculation.values.BA_FE_FEED_IN_CALC)-->
    <ng-container
      *ngIf="control?.value">
      <psc-select
        [hidden]="!advanced"
        @inOutAnimation
        formControlName="type_calculation"
        [label]="t('type_calculation.title')"
        [infoText]="t('type_calculation.info')"
        [isDisabled]="typeCalculationDisabled"
        [options]="typeCalculationOptions | translateLabels:g"></psc-select>
      <div *ngIf="typeCalculationDisabled && advanced" class="text-sm text-gray-600 -mt-4">
        *{{ t('only_registered_can_select') }}
      </div>
    </ng-container>
  </ng-container>
</ng-container>
